export default __webpack_public_path__ + "img/a2093c76b04d4ce7816dd9596b644b37.png";